module.exports = __webpack_public_path__ + "img/join_us_01.067c7384.jpg";